
import './MahutiInputText.css'
export default function MahutiInputText(props) {



        
    return <div className={`MahutiInputText ${props.error}`}>
        <input className='text-mahuti' id={props.id} onChange={(e) => props.onChange(e.target.value, props.id)} defaultValue={props.defaultValue} type="text" name="fname" aria-labelledby="placeholder-fname"/>
        <label className={"placeholder-text " + (props.required ? 'required' : '') } htmlFor="fname" id="placeholder-fname" aria-required>
            <div className="text">{props.label}</div>
        </label>
    </div>


}